import React from "react";
import { CheckCircle } from "lucide-react";
import Healthcycle from "./Healthcycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Grow Your Health & Wellness Business with WhatsApp",
  points: [
    "Recover lost sales with automated abandoned cart reminders.",
    "Share exciting deals and discounts through WhatsApp broadcasts.",
    "Display your wellness products beautifully in a WhatsApp catalog.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]" ,buttonLink:"https://app.chatmitra.com/signin",
    },
    { text: "Request a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_1.png",
};

const healthWellnessServices = [
  {
    id: 1,
    icon: <span className="text-2xl">🏋️</span>, // Weightlifting icon
    title: "Engage Clients with Fitness Tips on WhatsApp",
    description: "Send workout plans, nutrition advice, and motivation via WhatsApp. It’s like having a personal coach cheering them on every day!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">🧘</span>, // Yoga icon
    title: "Schedule Yoga Sessions via WhatsApp",
    description: "Let clients book classes, retreats, or meditation sessions easily on WhatsApp. It’s convenient and keeps them coming back for more zen."
  },
  {
    id: 3,
    icon: <span className="text-2xl">💉</span>, // Syringe icon
    title: "Provide Health Updates on WhatsApp",
    description: "Share vaccination schedules, wellness checks, and care tips through WhatsApp. Your clients will trust you more with every message."
  },
  {
    id: 4,
    icon: <span className="text-2xl">🍎</span>, // Apple icon
    title: "Promote Products with WhatsApp Deals",
    description: "Highlight supplements, organic products, or wellness kits via WhatsApp campaigns. It’s a direct line to boost sales and loyalty."
  },
  {
    id: 5,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Offer 24/7 Support on WhatsApp",
    description: "Answer health queries, provide mental health tips, and build trust with instant WhatsApp chats. Your clients will feel supported around the clock."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Collect Feedback via WhatsApp Surveys",
    description: "Ask for reviews on services, classes, or products through WhatsApp. It’s a quick way to improve and show you value their input."
  }
];

const healthWellnessFAQs = [
  {
    question: "How can WhatsApp grow my health and wellness business?",
    answer: "WhatsApp can boost your reach by sending fitness tips, wellness deals, and appointment reminders directly to clients. It’s like having a personal coach motivating them every day!"
  },
  {
    question: "Is WhatsApp safe for sharing health advice?",
    answer: "Yes, WhatsApp’s encryption ensures your tips, plans, and client data stay secure. It’s like locking your health insights in a safe, so clients trust you completely."
  },
  {
    question: "Can I book wellness sessions on WhatsApp?",
    answer: "Absolutely! Clients can schedule yoga classes, massages, or nutrition consultations via WhatsApp. It’s like making self-care as easy as texting a friend."
  },
  {
    question: "How does WhatsApp engage wellness clients?",
    answer: "Send motivational messages, healthy recipes, and loyalty rewards via WhatsApp. It’s like building a community that keeps coming back for more zen and vitality."
  },
  {
    question: "What health content should I share on WhatsApp?",
    answer: "Share workout videos, meditation guides, and product promotions through WhatsApp. It’s a direct line to inspire healthy living and drive sales effortlessly."
  },
  {
    question: "Can WhatsApp reduce customer service time for wellness businesses?",
    answer: "Yes! Automate responses to common questions and handle inquiries via WhatsApp, freeing your team for hands-on work. It’s like having an assistant who never takes a break."
  },
  {
    question: "How do clients feel about using WhatsApp for wellness?",
    answer: "They love it! Clients appreciate the convenience, speed, and personal touch of WhatsApp. It’s less formal than calls and more immediate, making wellness feel accessible."
  },
  {
    question: "Can WhatsApp promote wellness products effectively?",
    answer: "Definitely! Send exclusive deals on supplements or spa packages via WhatsApp. It’s like whispering special offers in their ear, turning interest into purchases."
  },
  {
    question: "How can I collect feedback using WhatsApp?",
    answer: "Ask for reviews on services or products via WhatsApp surveys. It’s a quick way to improve and show clients you value their input, boosting loyalty."
  },
  {
    question: "How do I start using WhatsApp for my wellness business?",
    answer: "Set up WhatsApp Business, create chat templates for bookings and tips, and use tools like ChatMitra to launch fast. It’s a simple step to transform your wellness brand!"
  },
];



const Health = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Grow Your Health & Wellness Business with WhatsApp</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
               <a
               key={index}
               href={button.buttonLink}
               className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
             >
               {button.text}
             </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Health & Wellness Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Ready to engage more customers and boost sales for your health and wellness brand? Start with ChatMitra today—no credit card required!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Healthcycle />
      <WhatsAppServices servicesData={healthWellnessServices} isVisible={true}/>
      <Faqs faqs={healthWellnessFAQs} />
      <title>Grow Your Health & Wellness Business with WhatsApp | ChatMitra</title>
      <meta name="description" content="Boost your health & wellness business with WhatsApp. Automate reminders, promote offers, and engage customers seamlessly with ChatMitra." />
      <meta name="keywords" content="WhatsApp for health and wellness, wellness marketing, health business automation, WhatsApp catalog, customer engagement" />
      <meta property="og:title" content="Grow Your Health & Wellness Business with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp to recover carts, promote wellness products, and keep customers engaged with personalized campaigns." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-health-wellness-brands" />
      <meta property="og:type" content="website" />
      <Footer />
    </>
  );
};

export default Health;